import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { customerListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE, IRoleEnum.STORE_EMPLOYEE];

const customerListRouteMetadata: IRouteMetadataObj<
  typeof customerListRoutesObj
> = {
  list: {
    title: "basicInfo.index.title",
    description: "empty",
    lazy: () => import("@pages/basicInfo/customer/table/page"),
    mode: "index",
    type: "main",
    icon: "Information2Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "basicInfo.customerManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/customer/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "basicInfo.customerManagement.edit.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/customer/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "basicInfo.customerManagement.view.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/customer/form/page"),
    mode: "view",
    type: "inner",
    icon: "Eye2Line",
    breadcrumbs: [],
    permission,
  },
  viewSalesInvoices: {
    title: "basicInfo.customerManagement.viewSalesInvoices.title",
    description: "empty",
    lazy: () =>
      import("@/pages/basicInfo/customer/viewSalesInvoices/table/page"),
    mode: "view",
    type: "inner",
    icon: "ShoppingCartLine",
    breadcrumbs: [],
    permission,
  },
  fullDebtSettlement: {
    title: "basicInfo.customerManagement.fullSettlementDebt.title",
    description: "empty",
    lazy: () =>
      import("@/pages/basicInfo/customer/viewSalesInvoices/fullDebtSettlement/view/page"),
    mode: "view",
    type: "inner",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  sendMessage: {
    title: "basicInfo.customerManagement.sendMessage.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/customer/sendMessage/form/page"),
    mode: "create",
    type: "inner",
    icon: "MessageLine",
    breadcrumbs: [],
    permission,
  },
};

export const customerListRoutes = createRoute<typeof customerListRoutesObj>(
  customerListRoutesObj,
  customerListRouteMetadata,
);
